import { __assign } from "tslib";
import React, { useMemo } from 'react';
var TorpedoItem = function (_a) {
    var layoutItem = _a.layoutItem, dataItem = _a.dataItem, renderItem = _a.renderItem;
    var itemStyle = {
        width: layoutItem.width,
        height: layoutItem.height,
    };
    var wrapStyles = {
        width: layoutItem.width,
        height: '100%',
        display: 'inline-block',
        float: 'left',
        position: 'relative',
        margin: layoutItem.margins,
    };
    var mergedItem = useMemo(function () { return (__assign(__assign({}, layoutItem), { dto: __assign(__assign({}, layoutItem.dto), dataItem) })); }, [layoutItem, dataItem]);
    // TODO kill the first param of the callback
    return (React.createElement("div", { style: wrapStyles }, dataItem ? (renderItem({}, mergedItem, itemStyle)) : (React.createElement("div", { style: itemStyle }))));
};
TorpedoItem.displayName = 'TorpedoItem';
export default TorpedoItem;
//# sourceMappingURL=TorpedoItem.js.map